// extracted by mini-css-extract-plugin
module.exports = {"root":"Video_root__25moz","thumbnail":"Video_thumbnail__3g99Z","image":"Video_image__2i1oL","metadata":"Video_metadata__1yR1F","title":"Video_title__X2uAx"};